import { Effect, Reducer, Subscription } from 'umi';
import { geRetentionData } from '../utils/interface';
import { REALTIME_USERTAG,REALTIME_RETENTION, REALTIME_NEW_ACTIVE_ONLINE, REALTIME_RETENTION_DAU,
  REALTIME_OVERALL_USER,
  REALTIME_CHANGE_NEW_ACTIVE_ONLINE,
  REALTIME_CHANGE_RETENTION_DAU,
} from './_config/filterDvaKey';

export const namespace = 'realtime';

const DashboardModel = {
  namespace: namespace,
  state: {
    data:{}
  },
  
  effects: {
    // 获取游戏列表
    *getUserTagDataFunc({payload}, { put }) {
      try {
        // const result: any = yield geRetentionData(payload);
        yield put({ type: "saveUserTag", payload: {[REALTIME_USERTAG]:payload}});
      } catch (e) {
        yield put({ type: "saveUserTag", payload: {
          
        }});
      }
    },
    *geRetentionDataFunc({payload}, { put }) {
      try {
        // const result: any = yield geRetentionData(payload);
        yield put({ type: "saveRetention", payload: {[REALTIME_RETENTION]:payload}});
      } catch (e) {
        yield put({ type: "saveRetention", payload: {
          
        }});
      }
    },
    *getNewActiveOnlineDataFunc({payload}, { put }) {
      try {
        yield put({ type: "saveNewActiveOnline", payload: {[REALTIME_NEW_ACTIVE_ONLINE]:payload}});
      } catch (e) {
        yield put({ type: "saveNewActiveOnline", payload: {
        }});
      }
    },
    *getRetentionDauDataFunc({payload}, { put }) {
      try {
        yield put({ type: "saveRetentionDau", payload: {[REALTIME_RETENTION_DAU]:payload}});
      } catch (e) {
        yield put({ type: "saveRetentionDau", payload: {
        }});
      }
    },
    *getOverallUserDataFunc({payload}, { put }) {
      try {
        yield put({ type: "saveOverallUser", payload: {[REALTIME_OVERALL_USER]:payload}});
      } catch (e) {
        yield put({ type: "saveOverallUser", payload: {
        }});
      }
    },
    *getChangeNewActiveOnlineDataFunc({payload}, { put }) {
      try {
        yield put({ type: "saveChangeNewActiveOnline", payload: {[REALTIME_CHANGE_NEW_ACTIVE_ONLINE]:payload}});
      } catch (e) {
        yield put({ type: "saveChangeNewActiveOnline", payload: {
        }});
      }
    },
    *getChangeRetentionDauDataFunc({payload}, { put }) {
      try {
        yield put({ type: "saveChangeRetentionDau", payload: {[REALTIME_CHANGE_RETENTION_DAU]:payload}});
      } catch (e) {
        yield put({ type: "saveChangeRetentionDau", payload: {
        }});
      }
    },
  },
  reducers: {
    saveUserTag(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
        
      };
    },
    saveRetention(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveNewActiveOnline(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveRetentionDau(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveOverallUser(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveChangeNewActiveOnline(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveChangeRetentionDau(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
  }
};

export default DashboardModel;
